"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireWildcard(require("react"));

var _ApplicationSettings = _interopRequireDefault(require("./HeaderSkeleton/services/ApplicationSettings"));

var _CarvanaHeaderSkeleton = _interopRequireDefault(require("./HeaderSkeleton/CarvanaHeaderSkeleton"));

var _MenuProvider = _interopRequireDefault(require("./HeaderSkeleton/Shared/MenuProvider"));

var _ScreenResizeProvider = _interopRequireWildcard(require("../providers/ScreenResizeProvider"));

var _getPartner = _interopRequireDefault(require("../utils/getPartner"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CarvanaHeader = function (_PureComponent) {
  _inherits(CarvanaHeader, _PureComponent);

  function CarvanaHeader(props) {
    var _this;

    _classCallCheck(this, CarvanaHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CarvanaHeader).call(this, props));

    _ApplicationSettings.default.setEnvironment(props.environment);

    _this.state = {
      partner: {}
    };
    return _this;
  }

  _createClass(CarvanaHeader, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(_regenerator.default.mark(function _callee() {
        var useProvider;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                useProvider = this.props.useProvider;

                if (useProvider) {
                  this.setState({
                    partner: (0, _getPartner.default)()
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          environment = _this$props.environment,
          profile = _this$props.profile,
          forceMobileLayout = _this$props.forceMobileLayout,
          useProvider = _this$props.useProvider,
          shouldShowCovid19Banner = _this$props.shouldShowCovid19Banner;
      var state = this.state;
      var partnerFromCookie = state.partner;
      var partnerFromProvider = profile && profile.partner;
      var skeletonPartner = useProvider ? partnerFromCookie : partnerFromProvider;
      return _react.default.createElement(_MenuProvider.default, {
        "data-qa": "carvana-header"
      }, _react.default.createElement(_ScreenResizeProvider.default, null, _react.default.createElement(_ScreenResizeProvider.ScreenResizeContext.Consumer, null, function (_ref) {
        var screenSize = _ref.screenSize;

        var _ref2 = screenSize || {},
            height = _ref2.height;

        return _react.default.createElement(_CarvanaHeaderSkeleton.default, {
          environment: environment,
          partner: skeletonPartner,
          forceMobileLayout: forceMobileLayout,
          screenHeight: height,
          shouldShowCovid19Banner: shouldShowCovid19Banner,
          "data-qa": "carvana-header"
        });
      })));
    }
  }]);

  return CarvanaHeader;
}(_react.PureComponent);

CarvanaHeader.defaultProps = {
  environment: 'development',
  favorites: {},
  profile: {},
  useModalUrlForAccountLinks: false,
  forceMobileLayout: false,
  useProvider: false,
  shouldShowCovid19Banner: false
};
var _default = CarvanaHeader;
exports.default = _default;
module.exports = exports.default;